import Flaring from '@/models/Flaring'
import User, { hasRole, Role } from '@/models/User'

export default class FlaringPolicy {
	viewAny(_user: User): boolean {
		return true
	}

	view(user: User, flaring: Flaring) {
		switch (user.role) {
			case Role.USER:
				return user.company?.id === flaring.entry.catalog.company.id
			case Role.AUDITOR:
				return flaring.entry.catalog.company.auditors?.some(auditor => auditor.id === user.auditor?.id)
			default:
				return false
		}
	}

	create(user: User) {
		return hasRole(user, Role.USER)
	}

	update(user: User, flaring: Flaring) {
		return hasRole(user, Role.USER) && user.company?.id === flaring.entry.catalog.company.id
	}

	restore(user: User, flaring: Flaring) {
		return hasRole(user, Role.USER) && user.company?.id === flaring.entry.catalog.company.id
	}

	delete(user: User, flaring: Flaring) {
		return hasRole(user, Role.USER) && user.company?.id === flaring.entry.catalog.company.id
	}

	forceDelete(_user: User, _flaring: Flaring) {
		return false
	}
}
